import { DayOfWeek } from "../common/DayOfWeek";
import { Course } from "../entity/Course";
import { TimeSlotDTO } from "../entity/TimeSlotDTO";

export interface CourseValidationObj {
  name: boolean;
  competitive: boolean;
  fee: boolean;
  capacity: boolean;
  color: boolean;
  description: boolean;
  trainingSchedule: boolean;
  timeSlots: boolean;
  coachLeadsCourses: boolean;
  memberInCourses: boolean;
}

export const courseValidationObjInit: CourseValidationObj = {
  name: true,
  competitive: true,
  fee: true,
  capacity: true,
  color: true,
  description: true,
  trainingSchedule: true,
  timeSlots: true,
  coachLeadsCourses: true,
  memberInCourses: true,
};

const validateTimeSlots = (timeSlots: TimeSlotDTO[]) => {
  return timeSlots.every(
    (ts) =>
      Object.keys(DayOfWeek).includes(ts.day) &&
      ts.startTime !== "" &&
      ts.endTime !== "" &&
      (ts.startTime < ts.endTime || ts.endTime.substring(0,5) === "00:00")
  );
};

const validateHexColor = (color: string) => {
  const hexRegex = /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/;
  return hexRegex.test(color);
};

export const validateCourse = (c: Course): CourseValidationObj => {
  const parsedFee = parseFloat(c.fee.toString());
  const parsedCapacity = parseFloat(c.capacity.toString());
  return {
    name: c.name.length > 0,
    competitive: true,
    fee: Number.isInteger(parsedFee) && c.fee >= 0,
    capacity: Number.isInteger(parsedCapacity) && c.capacity >= 0,
    color: validateHexColor(c.color),
    description: true,
    trainingSchedule: true,
    timeSlots: validateTimeSlots(c.timeSlots),
    coachLeadsCourses: true,
    memberInCourses: true,
  };
};
